import React, { useCallback } from "react";
import { useRouter } from 'next/router';
import cn from 'classnames';
import { useAppDispatch, useAppSelector } from 'redux-store';
import { goBack } from 'redux-store/slices/survey';

import logEvent from 'analytics/logEvent';

import BackIcon from './img/return.svg';
import BackWhiteIcon from './img/return-white.svg';

import styles from './styles.module.scss';

type Props = {
  onClick?: () => void;
  theme?: string;
  className?: string;
  /** Expands the hit area to 44x44 without changing the 24x24 layout box */
  tapTarget?: boolean;
//   back?: NavButtonConfig;
};

export default function SurveyBackButton({
  theme = 'white',
  onClick,
  className,
  tapTarget = false,
}: Props) {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { backPageUrl, currentPageUrl } = useAppSelector((state) => state.onboarding);

  const onClickBackButton = () => {
    logEvent('Web_Survey_Back_Clicked', {
      screen: currentPageUrl
    });

    if (typeof onClick !== 'function') {
      dispatch(goBack());
      router.push(backPageUrl);
    }
    else {
      onClick();
    }
  }

  // if (currentStep === -1 || currentStep === 0) {
  //   return null;
  // }

  const Icon = theme === 'dark' ? BackWhiteIcon : BackIcon;

  return (
    <button
      type="button"
      aria-label="Back"
      className={cn(styles.backButton, { [styles.tapTarget]: tapTarget }, className)}
      onClick={onClickBackButton}
    >
      <Icon width={24} />
    </button>
  );
}
